import * as PetChatbot from '.';

import { action } from '@play-co/replicant';
import { schedulePetChatMessage } from './petChatbot.scheduledActions';
import createActions from '../config/actions/createActions';

export const petChatbotActions = createActions({
  schedulePetActivity: action((state, __: void, api) => {
    const now = api.date.now();
    const chatMessage = PetChatbot.ruleset.getNextChatMessageSchedule(
      now,
      api.math.random(),
    );
    schedulePetChatMessage(state, chatMessage, now, api);
  }),
});
